export const stepBarStyles = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    p: 2,
    bgcolor: 'white',
    borderBottom: '1px solid #e3e6e9',
  },
  stepsRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    width: '100%',
  },
  stepItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  tickIcon: {
    fontSize: 16,
    color: '#007cbf',
  },
  stepLabel: (state: 'completed' | 'active' | 'pending') => ({
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: state === 'active' ? 700 : 400,
    fontSize: 12,
    color: state === 'completed' ? '#007cbf' : state === 'active' ? 'rgba(0, 0, 0, 0.87)' : 'rgba(0, 0, 0, 0.6)',
    letterSpacing: state === 'active' ? '0.14px' : '0.4px',
    textDecoration: state === 'completed' ? 'underline' : 'none',
  }),
  divider: {
    flex: 1,
    height: '1px',
    bgcolor: '#bdbdbd',
  },
  progress: {
    height: 8,
    borderRadius: '200px',
    bgcolor: '#f5f5f5',
    '& .MuiLinearProgress-bar': {
      borderRadius: '200px',
      background: 'linear-gradient(to right, #008ddb, #46c7fe)',
    },
  },
};